import { render, staticRenderFns } from "./LightRays.vue?vue&type=template&id=1ce0ae56&scoped=true&"
import script from "./LightRays.vue?vue&type=script&lang=js&"
export * from "./LightRays.vue?vue&type=script&lang=js&"
import style0 from "./LightRays.vue?vue&type=style&index=0&id=1ce0ae56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0ae56",
  null
  
)

export default component.exports